import github from '../../assets/Social/github.svg';
import linkedin from '../../assets/Social/linkedin.svg';

export const socialMedia=[{
    name:"GitHub",
    src:github,
    link:"https://github.com/harshavardhan1"
},{
    name:"Linkedin",
    src:linkedin,
    link:"https://www.linkedin.com/in/harshavardhan-dandu-0b888b162/"
}];

export const gmailLink='mailto:harshavardhandandu123@gmail.com';